if (!customElements.get('momento-faq')) {
  class MomentoFaq extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.querySelectorAll('[data-faq-item]').forEach((item) => {
        item.querySelector('[data-faq-trigger]')?.addEventListener('click', () => {
          this.setItemState(item, !item.classList.contains('is-open'));
        }, { signal });
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    setItemState(item, open) {
      const trigger = item.querySelector('[data-faq-trigger]');
      const panel = item.querySelector('[data-faq-panel]');
      const symbol = trigger?.querySelector('i');

      item.classList.toggle('is-open', open);
      trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel?.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (panel) panel.inert = !open;
      if (symbol) symbol.textContent = open ? '−' : '+';
    }
  }

  customElements.define('momento-faq', MomentoFaq);
}
